import type { Kmat, LinearConfiguration, LinearCstic } from "~/features/configurator/Linear/models";
import { getMainKmat } from "~/features/configurator/Shaft/common/commonShaftHelpers";

function makeFakeCstic(key: string, value: string | null): LinearCstic {
  return {
    value: value ?? "",
    groupId: "",
    key: key,
    name: key,
    label: key,
    values: [],
    type: "",
    description: "",
    info: "",
    readonly: false,
    fake: true,
  };
}

export function addFakeCstic(
  model: LinearConfiguration | LinearConfiguration | Kmat | Kmat[],
  csticName: string,
  csticValue: string | null,
): void;

export function addFakeCstic(
  model: LinearConfiguration | LinearConfiguration | Kmat | Kmat[],
  cstic: Partial<LinearCstic> & Pick<LinearCstic, "name">,
): void;

export function addFakeCstic(
  model: LinearConfiguration | LinearConfiguration | Kmat | Kmat[],
  csticName: (Partial<LinearCstic> & Pick<LinearCstic, "name">) | string,
  csticValue?: string | null,
): void {
  const name = typeof csticName === "string" ? csticName : csticName.name;
  const value = typeof csticName === "string" ? csticValue : csticName.value;
  let fakeCstic;
  if (typeof csticName === "string") {
    fakeCstic = makeFakeCstic(name, value ?? null);
  } else {
    fakeCstic = {
      ...makeFakeCstic(csticName.name, value ?? null),
      ...csticName,
    };
  }

  let mainKmat;
  if ("kmats" in model) {
    mainKmat = getMainKmat({ kmats: model.kmats })!;
  } else if (Array.isArray(model)) {
    mainKmat = model.find((kmat) => !kmat.parentId)!;
  } else {
    mainKmat = model;
  }

  mainKmat.cstics[name] = fakeCstic;
}
